<ng-container *ngTemplateOutlet="currentTemplate; context: context"></ng-container>

<ng-template #template_default let-title="title">
<div style="page-break-inside: avoid">
            <h5>{{ title}}</h5>
    <table class="optionalComponentSectionTable">
        <tr style="font-weight: bold;">
            <td style="text-align:left;padding-right:5px;">Type</td>
            <td style="text-align:right;padding-right:5px;">Capacity</td>
            <td style="text-align:left;padding-right:5px;">Terrain</td>
        </tr>

        <tr *ngFor="let processFacility of processFacilities">
            <td>{{ processFacility.fluidType }}</td>
            <td style="text-align:right;padding-right:5px;">{{ processFacility.capacity }} {{
                processFacility.capacityUnit }}</td>
            <td>{{ processFacility.terrain }}</td>
        </tr>
    </table>
</div>
</ng-template>

<ng-template #template_mobile let-title="title">
<div style="page-break-inside: avoid">
    <h5>{{ title }}</h5>
    <table class="optionalComponentSectionTable">
        <tr style="font-weight: bold;">
            <td style="text-align:left;padding-right:5px;">Type</td>
            <td style="text-align:right;padding-right:5px;">Capacity</td>
            <td style="text-align:left;padding-right:5px;">Terrain</td>
        </tr>

        <tr *ngFor="let processFacility of processFacilities">
            <td [innerHTML]="processFacility.fluidType | highlight:searchTerm"></td>
            <td style="text-align:right;padding-right:5px;">{{ processFacility.capacity }} {{
                processFacility.capacityUnit }}</td>
            <td [innerHTML]="processFacility.terrain | highlight:searchTerm"></td>
        </tr>

    </table>
</div>
</ng-template>